export default __webpack_public_path__ + "static/media/Notification.cdab88b4.svg";